const STEP_DATA_GRADE_10 = [
  {
    title: 'Khai đơn xét tuyển - Mẫu số 01',
    key: 'fill-info',
    step: 1
  },
  {
    title: 'Khai đơn xét tuyển - Mẫu số 02',
    key: 'register-group-expectation',
    step: 3
  },
 
]

const STEP_DATA_GRADE_6 = [
  {
    title: 'Khai đơn xét tuyển',
    key: 'fill-info',
    step: 1
  },
  {
    title: 'Kết quả xét tuyển',
    key: 'register-expectation',
    step: 2
  },
  {
    title: 'Nhập học trực tuyến',
    key: 'register-group-expectation',
    step: 3
  },
  {
    title: 'Nộp hồ sơ gốc',
    key: 'register-group-expectation',
    step: 4
  }
]
const STEP_DATA_GRADE_10_SUBMIT = [
  {
    title: 'Thông tin nhập học',
    key: 'fill-info',
    step: 1
  },
  {
    title: 'Thu hồ sơ gốc',
    key: 'register-expectation',
    step: 2
  },
  {
    title: 'Nhóm môn học',
    key: 'register-group-expectation',
    step: 3
  },
  {
    title: 'Dịch vụ',
    key: 'study-result',
    step: 4
  },
  {
    title: 'Thu tiền',
    key: 'exam-result',
    step: 5
  },
  {
    title: 'Khoá Nhóm môn học',
    key: 'restrict-expectation',
    step: 7
  },
  {
    title: 'Khoá Dịch vụ',
    key: 'restrict-service',
    step: 8
  },
  {
    title: 'Lịch sử chỉnh sửa',
    key: 'logs',
    step: 6
  }
]

const STEP_DATA_GRADE_6_SUBMIT = [
  {
    title: 'Thông tin nhập học',
    key: 'fill-info',
    step: 1
  },
  {
    title: 'Thu hồ sơ gốc',
    key: 'register-expectation',
    step: 2
  },
  {
    title: 'Dịch vụ',
    key: 'register-group-expectation',
    step: 3
  },
  {
    title: 'Thu tiền',
    key: 'exam-result',
    step: 4
  },
  {
    title: 'Khoá Dịch vụ',
    key: 'restrict-service',
    step: 6
  },
  {
    title: 'Lịch sử chỉnh sửa',
    key: 'logs',
    step: 5
  }
]

const STEP_DATA_GRADE_1_SUBMIT = [
  {
    title: 'Thông tin nhập học',
    key: 'fill-info',
    step: 1
  },
  {
    title: 'Thu hồ sơ gốc',
    key: 'register-expectation',
    step: 2
  },
  {
    title: 'Dịch vụ',
    key: 'register-group-expectation',
    step: 3
  },
  {
    title: 'Thu tiền',
    key: 'exam-result',
    step: 4
  },
  {
    title: 'Khoá Dịch vụ',
    key: 'restrict-service',
    step: 6
  },
  {
    title: 'Lịch sử chỉnh sửa',
    key: 'logs',
    step: 5
  }
]
const LIST_COMPETITION_10 = [
  {
    text: 'Cuộc thi Thách thức tài năng Toán học Việt Nam - VMTC',
    value: 'vmtc',
    prizes: ['Giải Vàng', 'Giải Bạc', 'Giải Đồng']
  },
  {
    text: 'Kì thi Toán học Hà Nội mở rộng HOMC',
    value: 'homc',
    prizes: ['Giải Vô địch', 'Giải Vàng/Giải Nhất', 'Giải Bạc/Giải Nhì', 'Giải Đồng/Giải Ba']
  },
  {
    text: 'Kỳ thi Toán Quốc tế Kangaroo IKMC',
    value: 'ikmc',
    prizes: [
      'Vô Địch Quốc Gia (National Champion)',
      'Xuất Sắc (High Distinction- Vàng)',
      'Giỏi (Distinction- Bạc)',
      'Top 10% Và 15% (Đồng)'
    ]
  },
  {
    text: 'Kỳ thi Thử thách Toán học quốc tế IMC',
    value: 'imc',
    prizes: ['Giải Nhất', 'Giải Nhì', 'Giải Ba']
  },
  {
    text: 'Kỳ thi đánh giá năng lực tư duy Toán học quốc tế IMAS',
    value: 'imas',
    prizes: ['Giải Vàng', 'Giải Bạc', 'Giải Đồng']
  },
  {
    text: 'Olympic Thách thức Toán học Quốc tế Singapore - SIMOC',
    value: 'simoc',
    prizes: ['Giải Vàng', 'Giải Bạc', 'Giải Đồng']
  },
  {
    text: 'Kì thi Toán học Hoa Kỳ - AMC8',
    value: 'amc8',
    prizes: [
      'Giải vô địch (Distinction- D)',
      'Giải Loại Xuất sắc (Honor Roll of Distinction- HD)',
      'Giải loại Giỏi (Honor Roll -H)'
    ]
  },
  {
    text: 'Đấu trường Toán học Châu Á - AIMO',
    value: 'aimo',
    prizes: ['Giải Vàng', 'Giải Bạc', 'Giải Đồng']
  },
  {
    text: 'Kỳ thi Olympic Toán học quốc tế HKIMO',
    value: 'hkimo',
    prizes: ['Giải Vàng', 'Giải Bạc', 'Giải Đồng', 'Giải Quốc tế']
  },
  {
    text: 'Kỳ thi Olympic Toán học quốc tế TIMO',
    value: 'timo',
    prizes: ['Giải Vàng', 'Giải Bạc', 'Giải Đồng', 'Giải Quốc tế']
  },
  {
    text: 'Kỳ thi Thách thức tư duy thuật toán Bebras',
    value: 'bebras',
    prizes: [
      'Giải vô địch (Distinction- D)',
      'Giải Loại Xuất sắc (Honor Roll of Distinction- HD)',
      'Giải loại Giỏi (Honor Roll - H)'
    ]
  },
  {
    text: 'Tìm kiếm tài năng Toán học quốc tế ITMC',
    value: 'itmc',
    prizes: ['Giải Vàng', 'Giải Bạc', 'Giải Đồng']
  },
  {
    text: 'Kỳ thi Toán học quốc tế WMI',
    value: 'wmi',
    prizes: ['Giải Kim Cương', 'Giải Vàng', 'Giải Bạc', 'Giải Đồng']
  },
  {
    text: 'Kỳ thi Toán học quốc tế AMO',
    value: 'amo',
    prizes: ['Giải Vàng', 'Giải Bạc', 'Giải Đồng']
  },
  {
    text: 'Kỳ thi Olympic Toán học Úc - AMC Úc',
    value: 'amc_aus',
    prizes: [
      "Peter O'Halloran Award For Excellence (Điểm Tuyệt Đối)",
      'Hạng Prize (Điểm Cao Nhất)',
      'Hạng High Distinction (3%)',
      'Hạng Distinction (25%)'
    ]
  },
  {
    text: 'Kỳ thi đánh giá năng lực Toán tiếng Anh toàn cầu - SEAMO X',
    value: 'seamo',
    prizes: ['Giải Vàng', 'Giải Bạc', 'Giải Đồng', 'Giải Quốc tế']
  },
  {
    text: 'Kỳ thi Olympic Khoa học quốc tế HKISO',
    value: 'hkiso',
    prizes: ['Giải Vàng', 'Giải Bạc', 'Giải Đồng', 'Giải Quốc tế']
  },
  {
    text: 'Kỳ thi Olympic quốc tế Khoa học, Toán và Tiếng Anh - ASMO',
    value: 'asmo',
    prizes: ['Giải Vàng', 'Giải Bạc', 'Giải Đồng', 'Giải Quốc tế']
  },
  {
    text: 'Kỳ thi Olympic Tiếng Anh quốc tế HIPPO',
    value: 'hippo',
    prizes: ['Giải Vàng', 'Giải Bạc', 'Giải Đồng', 'Giải Quốc tế']
  },
  {
    text: 'Cuộc thi Olympic tiếng Anh trên Internet - IOE',
    value: 'ioe',
    prizes: ['Giải Nhất', 'Giải Nhì', 'Giải Ba', 'Giải Khuyến Khích']
  },
  {
    text: 'Cuộc thi Imagine Cup Junior quốc tế',
    value: 'imagine_cup',
    prizes: ['Top 20 quốc gia', 'Top toàn cầu']
  },
  {
    text: 'Kỳ thi Olympic Tin học quốc tế HKICO',
    value: 'hkico',
    prizes: ['Giải Ngôi sao Thế giới', 'Giải Xuất sắc', 'Giải Vàng', 'Giải Bạc', 'Giải Đồng']
  },
  {
    text: 'Solve for Tomorrow',
    value: 'solve_tomorrow',
    prizes: ['Giải Nhất', 'Giải Nhì', 'Giải Ba', 'Giải Triển vọng', 'Giải Bình chọn']
  },
  {
    text: 'Cuộc Thi Toán Mô Hình',
    value: 'toan_mo_hinh',
    prizes: ['Giải Quán Quân', 'Giải Á Quân', 'Giải Quý Quân']
  },
  {
    text: 'Hội thi Tin học trẻ',
    value: 'tin_hoc_tre',
    prizes: ['Giải Nhất', 'Giải Nhì', 'Giải Ba', 'Giải vòng chung kết']
  },
  {
    text: 'Kỳ thi Olympic tiếng Anh Tp. Hà Nội',
    value: 'olympic_eng_hanoi',
    prizes: ['Giải Đặc Biệt', 'Giải Nhất', 'Giải Nhì', 'Giải Ba']
  },
  {
    text: 'Kì thi Toán Singapore và Châu Á (SASMO)',
    value: 'sasmo',
    prizes: ['Giải Điểm tuyệt đối', 'Giải Vàng', 'Giải Bạc', 'Giải Đồng']
  },
  {
    text: 'Học sinh, sinh viên với ý tưởng khởi nghiệp (SV. STARTUP)',
    value: 'sv_startup',
    prizes: ['Giải Nhất', 'Giải Nhì', 'Giải Ba', 'Giải Khuyến Khích']
  },
  {
    text: 'Tuổi trẻ học tập và làm theo tấm gương đạo đức Hồ Chí Minh',
    value: 'tuoi_tre_hcm',
    prizes: ['Giải Nhất', 'Giải Nhì', 'Giải Ba', 'Giải Khuyến Khích']
  },
  {
    text: 'An toàn giao thông cho nụ cười ngày mai',
    value: 'atgt',
    prizes: ['Giải Nhất', 'Giải Nhì', 'Giải Ba', 'Giải Khuyến Khích']
  },
  {
    text: 'Viết thư quốc tế UPU',
    value: 'upu',
    prizes: ['Giải Nhất', 'Giải Nhì', 'Giải Ba', 'Giải Khuyến Khích']
  },
  {
    text: 'Hội khỏe Phù Đổng toàn quốc',
    value: 'hkpd',
    prizes: ['Giải Vàng', 'Giải Bạc', 'Giải Đồng']
  }
]
export default {
  STEP_DATA_GRADE_10,
  STEP_DATA_GRADE_6,
  STEP_DATA_GRADE_10_SUBMIT,
  STEP_DATA_GRADE_6_SUBMIT,
  STEP_DATA_GRADE_1_SUBMIT,
  LIST_COMPETITION_10
}
